import { useEffect, useRef } from 'react';
import { EVENTS, track } from '../helpers/analytics';
import { clearUtm, getUtm, utmProps } from '../helpers/utm';

/**
 * Fire `Signup Completed` exactly once when the user lands on onboarding with a
 * UTM stash left by the /signup route (which survived the Auth0 round-trip in
 * localStorage). Clears the stash so it fires only for this conversion and not
 * on later add-store visits. No-ops for organic signups (empty stash).
 */
export function useSignupCompletion(): void {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) {
      return;
    }

    const utm = getUtm();
    if (Object.keys(utm).length > 0) {
      track(EVENTS.signupCompleted, utmProps(utm));
      clearUtm();
    }

    fired.current = true;
  }, []);
}
